import { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import { calculateTimeLeft, formatTime } from "./TimeUtility";

export default function SessionTimer({ onLogout, onProgress }) {
    const [timeLeft, setTimeLeft] = useState("--:--");
    const [progress, setProgress] = useState(100);

    const timerRef = useRef(null);
    const alertShownRef = useRef(false);
    const initialDurationRef = useRef(null);

    useEffect(() => {
        const refreshExpiry = Number(Cookies.get("refreshTokenTime"));
        if (!refreshExpiry) return;

        initialDurationRef.current = refreshExpiry - Date.now();
        alertShownRef.current = false;

        const updateTimer = () => {
            // ── Always read fresh cookie each tick ──────────────────────
            const latestRefreshExpiry = Number(Cookies.get("refreshTokenTime"));

            // ── Cookie missing → logout ─────────────────────────────────
            if (!latestRefreshExpiry) {
                clearInterval(timerRef.current);
                if (!alertShownRef.current) {
                    alertShownRef.current = true;
                    Swal.fire({
                        title: "Session Expired",
                        text: "Please login again",
                        icon: "warning",
                        confirmButtonText: "OK",
                        allowOutsideClick: false,
                    }).then(() => { if (onLogout) onLogout(); });
                }
                return;
            }

            const remaining = calculateTimeLeft(latestRefreshExpiry);

            setTimeLeft(formatTime(remaining));

            const newProgress = initialDurationRef.current > 0
                ? Math.max(0, (remaining / initialDurationRef.current) * 100)
                : 0;
            setProgress(newProgress);
            if (onProgress) onProgress(newProgress);

            // ── Refresh token expired → logout ──────────────────────────
            if (remaining <= 0 && !alertShownRef.current) {
                alertShownRef.current = true;
                clearInterval(timerRef.current);
                Swal.fire({
                    title: "Session Expired",
                    text: "Please login again",
                    icon: "warning",
                    confirmButtonText: "OK",
                    allowOutsideClick: false,
                }).then(() => { if (onLogout) onLogout(); });
            }
        };

        updateTimer();
        timerRef.current = setInterval(updateTimer, 1000);
        return () => clearInterval(timerRef.current);

        // eslint-disable-next-line
    }, []);

    return (
        <div className="session-timer-container">
            <div className="timer-box">
                <span className="timer-text">{timeLeft}</span>
            </div>
        </div>
    );
}